import './App.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import "./fontawesome/css/all.min.css";
import { Route, Routes, Navigate } from 'react-router-dom';
import { APP_ROUTES } from './config/appRoutes';
import Login from './pages/Login/Login';
import PrivateRoute from './context/PrivateRoute';
import MainLayout from './components/MainLayout/MainLayout';
import PageNotFound from './components/PageNotFound/PageNotFound';
import RestrictedPage from './components/RestrictedPage/RestrictedPage';
import Dashboard from './pages/Dashboard/Dashboard';
import Profile from './pages/Profile/Profile';

import Employee from './pages/Employee/Employee';
import EmployeeHistory from './pages/Employee/EmployeeHistory/EmployeeHistory';
import EmployeeCreation from './pages/Employee/EmployeeCreation/EmployeeCreation';

import Training from './pages/Training/Training';
import TrainingCreation from './pages/Training/TrainingCreation/TrainingCreation';
import TrainingHistory from './pages/Training/TrainingHistory/TrainingHistory';
import TrainingEdit from './pages/Training/TrainingEdit/TrainingEdit';
import TrainingReport from './pages/Training/TrainingReport/TrainingReport';

import FieldBook from './pages/FieldBook/FieldBook';
import FieldBookHistory from './pages/FieldBook/FieldBookHistory/FieldBookHistory';
import FieldBookCreation from './pages/FieldBook/FieldBookCreation/FieldBookCreation';
import FieldBookEdit from './pages/FieldBook/FieldBookEdit/FieldBookEdit';
import FieldBookSummaryReport from './pages/FieldBook/FieldBookSummaryReport/FieldBookSummaryReport';

import TrainingSession from './pages/TrainingSession/TrainingSession';
import TrainingSessionHistory from './pages/TrainingSession/TrainingSessionHistory/TrainingSessionHistory';
import TrainingSessionCreation from './pages/TrainingSession/TrainingSessionCreation/TrainingSessionCreation';
import TrainigSessionFeedBack from './pages/TrainingSession/TrainingSessionFeedBack/TrainingSessionFeedBack';
import TrainingSessionAttendance from './pages/TrainingSession/TrainingSessionAttendance/TrainingSessionAttendance';
import TrainingSessionPlanHistoryDetails from './pages/TrainingSession/TrainingSessionPlanHistory/TrainingSessionPlanHistory';


import SoilReport from './pages/SoilReport/SoilReport';
import SoilReportCreation from './pages/SoilReport/SoilReportCreation/SoilReportCreation';
import SoilReportHistory from './pages/SoilReport/SoilReportHistory/SoilReportHistory';
import SoilReportEdit from './pages/SoilReport/SoilReportEdit/SoilReportEdit';
import SoilReportVillageEdit from './pages/SoilReport/SoilReportVillageEdit/SoilReportVillageEdit';
import SoilSummaryReport from './pages/SoilReport/SoilSummaryReport/SoilSummaryReport';


import AdoptionMain from './pages/AdOption/AdoptionMain';
import AdOptionHistory from './pages/AdOption/AdOptionHistory/AdOptionHistory';
import AdOptionCreation from './pages/AdOption/AdOptionCreation/AdOptionCreation';
import AdOptionEdit from './pages/AdOption/AdOptionEdit/AdOptionEdit';
import AdOptionSummaryReport from './pages/AdOption/AdOptionSummaryReport/AdOptionSummaryReport';
import AdOptionOveralReport from './pages/AdOption/AdOptionOveralReport/AdOptionOveralReport';

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path={APP_ROUTES.LOGIN} element={<Login />} />
        <Route element={<PrivateRoute />}>
          <Route element={<MainLayout />}>
            <Route path={APP_ROUTES.DASHBOARD} element={<Dashboard />} />
            <Route path={APP_ROUTES.EMPLOYEE.ROOT} element={<Employee />}>
              <Route index element={<Navigate to={APP_ROUTES.EMPLOYEE.HISTORY} />} />
              <Route path={APP_ROUTES.EMPLOYEE.HISTORY} element={<EmployeeHistory />} />
              <Route path={APP_ROUTES.EMPLOYEE.CREATION} element={<EmployeeCreation />} />
            </Route>

            <Route path={APP_ROUTES.TRAINING.ROOT} element={<Training />}>
              <Route index element={<Navigate to={APP_ROUTES.TRAINING.HISTORY} />} />
              <Route path={APP_ROUTES.TRAINING.HISTORY} element={<TrainingHistory />} />
              <Route path={APP_ROUTES.TRAINING.CREATION} element={<TrainingCreation />} />
              <Route path={`${APP_ROUTES.TRAINING.HISTORY}/${APP_ROUTES.TRAINING.HISTORY_ROUTES.EDIT}`} element={<TrainingEdit />} />
              <Route path={`${APP_ROUTES.TRAINING.HISTORY}/${APP_ROUTES.TRAINING.HISTORY_ROUTES.REPORT}`} element={<TrainingReport />} />
            </Route>

            <Route path={APP_ROUTES.TRAININGSESSION.ROOT} element={<TrainingSession />}>
              <Route index element={<Navigate to={APP_ROUTES.TRAININGSESSION.HISTORY} />} />
              <Route path={APP_ROUTES.TRAININGSESSION.HISTORY} element={<TrainingSessionHistory />} />
              <Route path={APP_ROUTES.TRAININGSESSION.CREATION} element={<TrainingSessionCreation />} />
              <Route path={`${APP_ROUTES.TRAININGSESSION.HISTORY}/${APP_ROUTES.TRAININGSESSION.HISTORY_ROUTES.FEEDBACK}`} element={<TrainigSessionFeedBack />} />
              <Route path={`${APP_ROUTES.TRAININGSESSION.HISTORY}/${APP_ROUTES.TRAININGSESSION.HISTORY_ROUTES.ATTENDANCE}`} element={<TrainingSessionAttendance />} />
              <Route path={`${APP_ROUTES.TRAININGSESSION.HISTORY}/${APP_ROUTES.TRAININGSESSION.HISTORY_ROUTES.SISSIONPLAN_HISTORY}`} element={<TrainingSessionPlanHistoryDetails />} />
            </Route>

            <Route path={APP_ROUTES.SOILREPORT.ROOT} element={<SoilReport />}>
              <Route index element={<Navigate to={APP_ROUTES.SOILREPORT.HISTORY} />} />
              <Route path={APP_ROUTES.SOILREPORT.HISTORY} element={<SoilReportHistory />} />
              <Route path={APP_ROUTES.SOILREPORT.CREATION} element={<SoilReportCreation />} />
              <Route path={APP_ROUTES.SOILREPORT.SUMMARYREPORT} element={<SoilSummaryReport />} />
              <Route path={`${APP_ROUTES.SOILREPORT.HISTORY}/${APP_ROUTES.SOILREPORT.HISTORY_ROUTES.EDIT}`} element={<SoilReportEdit />} />
              <Route path={`${APP_ROUTES.SOILREPORT.HISTORY}/${APP_ROUTES.SOILREPORT.HISTORY_ROUTES.VILLAGEEDIT}`} element={<SoilReportVillageEdit />} />
            </Route>

            <Route path={APP_ROUTES.FIELDBOOK.ROOT} element={<FieldBook />}>
              <Route index element={<Navigate to={APP_ROUTES.FIELDBOOK.HISTORY} />} />
              <Route path={APP_ROUTES.FIELDBOOK.HISTORY} element={<FieldBookHistory />} />
              <Route path={APP_ROUTES.FIELDBOOK.CREATION} element={<FieldBookCreation />} />
              <Route path={APP_ROUTES.FIELDBOOK.SUMMARYREPORT} element={<FieldBookSummaryReport />} />
              <Route path={`${APP_ROUTES.FIELDBOOK.HISTORY}/${APP_ROUTES.FIELDBOOK.HISTORY_ROUTES.EDIT}`} element={<FieldBookEdit />} />
            </Route>


            <Route path={APP_ROUTES.ADOPTION.ROOT} element={<AdoptionMain />}>
              <Route index element={<Navigate to={APP_ROUTES.ADOPTION.HISTORY} />} />
              <Route path={APP_ROUTES.ADOPTION.HISTORY} element={<AdOptionHistory />} />
              <Route path={APP_ROUTES.ADOPTION.CREATION} element={<AdOptionCreation />} />
              <Route path={APP_ROUTES.ADOPTION.SUMMARYREPORT} element={<AdOptionSummaryReport />} />
              <Route path={APP_ROUTES.ADOPTION.OVERALSUMMARY} element={<AdOptionOveralReport />} />
              <Route path={`${APP_ROUTES.ADOPTION.HISTORY}/${APP_ROUTES.ADOPTION.HISTORY_ROUTES.EDIT}`} element={<AdOptionEdit />} />
            </Route>

            <Route path="/restricted" element={<RestrictedPage />} />
            <Route path={APP_ROUTES.PROFILE} element={<Profile />} />
          </Route>
        </Route>
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
}
export default App;